import { constants } from '@yola/subscription-manager-js';
import { t } from '../../localization';

const { MONTHLY } = constants.SubscriptionTerm;

const processFreeSubdomainData = ({
  isUpgradeToPublishEnabled,
  isSpecialOfferEnabled,
  canGetDomainForFree,
  activeSubscriptionTerm,
}) => {
  let props = {
    isSticky: true,
  };
  let captions = {
    title: '*.yolasite.com',
    description: t('Publish your website to a free temporary subdomain'),
  };

  if (isUpgradeToPublishEnabled) {
    const withSpecialOffer =
      isSpecialOfferEnabled && !canGetDomainForFree && activeSubscriptionTerm !== MONTHLY;

    props = {
      ...props,
      ...(withSpecialOffer && {
        buttonAppearance: 'accent',
        priceAppearance: 'success',
      }),
    };
    captions = {
      ...captions,
      price: t('FREE'),
      button: t('Get'),
      priceDescription: withSpecialOffer ? t('with annual plan') : t('with premium plans'),
    };
  } else {
    props = {
      ...props,
      buttonFormat: 'outline',
    };
    captions = {
      ...captions,
      button: t('Continue for free'),
    };
  }

  return {
    ...props,
    captions,
  };
};

export default processFreeSubdomainData;
